<div class="mx-auto">

<div data-controller="info-box">
  <div class="info-button">&#x24D8;</div>
  <ul class="info-box">
  <li>This summary provides a comprehensive overview of all participants, packages, and heats for your event.
  <li><strong>People section</strong>: Click any type or role to filter the people list. Shows total counts by type (Professional, Student, Guest, Judge, etc.) and role (Leader, Follower).
  <li><strong>Packages</strong>: View registration package distribution.
  <li><strong>Options</strong>: Track optional add-ons (meals, social events, etc.).
  <li><strong>Students by level/age</strong>: Quick filtering by dance level or age category.
  <li><strong>Heats by Studio</strong>: Shows total heat count for each participating studio.
  </ul>
</div>

<h1 class="font-bold text-center text-4xl mb-6">Event Summary</h1>

<div class="grid grid-cols-1 md:grid-cols-3 gap-6">
  <div>
    <h2 class="font-bold text-2xl mb-4">People</h2>
    <ul class="list-disc list-inside">
      <% @people_by_type.keys.sort.each do |type| %>
        <% members = @people_by_type[type] %>
        <li><%= link_to type, people_path(type: type) %>: <%= members.length %></li>

        <% if %w[Professional Student].include?(type) %>
        <% roles = members.group_by(&:role) %>
        <ul class="ml-4 list-disc list-inside">
          <% roles.keys.sort.each do |role| %>
            <li><%= link_to role, people_path(type: type, role: role) %>: <%= roles[role].length %></li>
          <% end %>
        </ul>
        <% end %>
      <% end %>
    </ul>

    <% if @package_summary.length > 0 %>
    <h2 class="font-bold text-2xl mt-6 mb-4">Packages</h2>
    <ul class="list-disc list-inside">
      <% @package_summary.each do |pkg_group| %>
        <li><%= pkg_group[:type] %>
        <ul class="ml-4 list-disc list-inside">
        <% pkg_group[:packages].each do |pkg| %>
          <li><%= pkg[:name] %>: <%= pkg[:count] %></li>
        <% end %>
        </ul>
      <% end %>
    </ul>
    <% end %>

    <% if @option_summary.length > 0 %>
    <h2 class="font-bold text-2xl mt-6 mb-4">Options</h2>
    <ul class="list-disc list-inside">
      <% @option_summary.each do |opt| %>
        <li><%= opt[:name] %>: <%= opt[:count] %></li>
      <% end %>
    </ul>
    <% end %>

    <% if @has_questions %>
    <div class="mt-6">
      <%= link_to "View Question Answers", answers_path, class: "btn-pale-blue" %>
    </div>
    <% end %>
  </div>

  <div>
    <% if @level_summary.length > 0 %>
    <h2 class="font-bold text-2xl mb-4">Students, by level</h2>
    <ul class="list-disc list-inside">
      <% @level_summary.each do |entry| %>
        <li><%= link_to entry[:name], people_path(level: entry[:id]) %>: <%= entry[:count] %></li>
      <% end %>
    </ul>

    <% if @track_ages && @age_summary.length > 0 %>
    <h2 class="font-bold text-2xl mt-6 mb-4">Students, by age</h2>
    <ul class="list-disc list-inside">
      <% @age_summary.each do |entry| %>
        <li><%= link_to "#{entry[:category]} (#{entry[:description]})", people_path(age: entry[:id]) %>: <%= entry[:count] %></li>
      <% end %>
    </ul>
    <% end %>
    <% end %>
  </div>

  <div>
    <h2 class="font-bold text-2xl mb-4">Heats, by Studio</h2>
    <ul class="list-disc list-inside">
      <% @heats_by_studio.each do |entry| %>
        <li><%= entry[0] %>: <%= entry[1] %></li>
      <% end %>
    </ul>
  </div>
</div>

<h2 class="font-bold text-2xl my-4">See also:</h2>

<div class="grid grid-cols-3 gap-1">
<%= link_to "Dances", dances_path, class: "btn-pale-blue" %>
<%= link_to "Categories", categories_path, class: "btn-pale-blue" %>
<%= link_to "Settings", settings_event_index_path, class: "btn-pale-blue" %>
</div>

</div>
